import { Component } from '@angular/core';
import { BANNER } from './banner';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  readonly banner = BANNER;
}
